import type {
  ComplexQuestion,
  ComplexQuestionInsert,
} from "@repo/app-types/entities/question";
import type { FC } from "react";
import { MatrixQuestionEditor } from "./matrixQuestionEditor.js";
import { MultipleChoiceQuestionEditor } from "./multipleChoiceQuestionEditor.js";

interface ComplexQuestionEditorProps {
  question: ComplexQuestion | ComplexQuestionInsert;
  onChange: (question: ComplexQuestion | ComplexQuestionInsert) => void;
}

export const ComplexQuestionEditor: FC<ComplexQuestionEditorProps> = ({
  question,
  onChange,
}) => {
  switch (question.type) {
    case "rating": {
      return <MatrixQuestionEditor question={question} onChange={onChange} />;
    }
    case "multiple_choice": {
      return (
        <MultipleChoiceQuestionEditor question={question} onChange={onChange} />
      );
    }
  }
};
